import { render, staticRenderFns } from "./formularioTromboembolico.vue?vue&type=template&id=6ae5af72&scoped=true"
import script from "./formularioTromboembolico.vue?vue&type=script&lang=js"
export * from "./formularioTromboembolico.vue?vue&type=script&lang=js"
import style0 from "./formularioTromboembolico.vue?vue&type=style&index=0&id=6ae5af72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae5af72",
  null
  
)

export default component.exports